const VERSION: string = import.meta.env.VITE_APP_VERSION ?? "";
const COMMIT: string = import.meta.env.VITE_APP_COMMIT ?? "";
const BUILD_DATE: string = import.meta.env.VITE_BUILD_DATE ?? "";

export function formatBuildStamp(
  version: string,
  commit: string,
  buildDateIso: string,
): string {
  const parts: string[] = [];
  if (version) parts.push(commit ? `v${version} (${commit})` : `v${version}`);
  const date = new Date(buildDateIso);
  if (buildDateIso && !Number.isNaN(date.getTime())) {
    parts.push(
      date.toLocaleDateString(undefined, {
        day: "numeric",
        month: "short",
        year: "numeric",
      }),
    );
  }
  return parts.join(" · ");
}

export function VersionFooter() {
  const stamp = formatBuildStamp(VERSION, COMMIT, BUILD_DATE);
  if (!stamp) return null;
  return (
    <footer className="pt-2 text-center text-[11px] text-slate-600 tabular-nums">
      {stamp}
    </footer>
  );
}
